<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware/>

    <!-- hero section -->
    <HeroSoftware/>

    <!-- brand logo carousel -->
    <!--    <BrandLogoCarousel/>-->

    <!-- business analytics start -->
    <div class="feature-icon-list-area section-space--pb_120 section-space--mt_40" id="about">
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_100">
          <h2 class="section-title font-weight--light mb-30 wow move-up" style="font-size: 48px">
            In-depth features Available
            at <br> Your Hand</h2>
        </div>
      </div>
      <!-- feature list component -->
      <FeatureList/>
    </div>

    <!-- three step process -->
    <ThreeStepProcessWrap/>

    <div>
      <b-embed aspect="21by9"
               type="video"
               controls
               poster="https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/poster.PNG"
      >
        <source
          src="https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/YourSynchronicityBranding.mp4"
          type="video/mp4">
      </b-embed>

    </div>

    <!-- skill area start -->
    <SassFeature class="gray-gradient" id="Sassservice"/>
    <!--    <div class="embed-responsive embed-responsive-21by9" >-->
    <!--      <iframe class="embed-responsive-item"-->
    <!--              src="https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/YourSynchronicityBranding.mp4"-->
    <!--              allowfullscreen></iframe>-->
    <!--    </div>-->


<!--            &lt;!&ndash; pricing section &ndash;&gt;-->
        <CurveShape>
            <template v-slot:bgcolor>
                <path style="fill: #f6f5f9;
                    stroke-miterlimit:10;"
                    d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"/>
            </template>
        </CurveShape>
        <div class="pricing-table-area bg-gray-2 section-space--pb_90" id="pricing">
            <div class="pricing-table-title-area position-relative ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12  wow move-up">
                            <div class="section-title-wrapper text-center section-space--mb_60">
                                <h2 class="section-title font-weight--light mb-15 wow move-up">Affordable for everyone!</h2>
                                <span class="section-text wow move-up">If you are planning on developing your business. <br> One simple price, All Cloud Based features included with the support of our best social media expert. Cancel Anytime.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pricing-table-content-area">
                <div class="container">
                    <!-- pricing component -->
                    <PricingOne />
                </div>
            </div>
        </div>

    <div class="software-accordion-wrapper section-space--pt_120 section-space--pb_60 gray-gradient"
         id="faq">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-wrapper text-center section-space--mb_60">
              <h2 class="section-title font-weight--light mb-10 wow move-up"
                  style="font-size: 48px;">Frequently Asked
                Questions</h2>
              <span class="section-text wow move-up">It’s our pleasure to answer any questions you have</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="faq-wrapper">
              <!-- accordion component -->
              <Accordion/>
            </div>
          </div>

        </div>
      </div>
    </div>
    <CurveShape class="curve-bottom">
      <template v-slot:bgcolor>
        <path style="fill: #f6f5f9;
                    stroke-miterlimit:10;"
              d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"/>
      </template>
    </CurveShape>

    <!-- bannar area -->
    <div class="software-contact__images section-space--pt_120 section-space--pb_60">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="software-contact-images__midea text-center wow move-up">
              <img src="../assets/img/features/aeroland-software-image-06.png" alt=""
                   class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- newsletter section -->
    <Newsletter/>

    <!-- footer section -->
    <FooterMain/>

    <!-- offcanvas search component -->
    <!--        <OffcanvasSearchBox />-->

  </div>
</template>

<script>

    import ThreeStepProcessWrap from "../components/AeroLandingPage/ThreeStepProcessWrap";
    import HeaderSoftware from "../components/AeroLandingPage/HeaderSoftware";
    import HeroSoftware from "../components/AeroLandingPage/HeroSoftware";
    import BrandLogoCarousel from "../components/AeroLandingPage/BrandLogoCarousel";
    import FeatureList from "../components/AeroLandingPage/FeatureList";
    import TabTwo from "../components/AeroLandingPage/TabTwo";
    import ProgressBar from "../components/AeroLandingPage/ProgressBar";
    import PricingOne from "../components/AeroLandingPage/PricingOne";
    import CurveShape from "../components/AeroLandingPage/CurveShape";
    import CtaThree from "../components/AeroLandingPage/CtaThree";
    import FunFactOne from "../components/AeroLandingPage/FunFactOne";
    import Accordion from "../components/AeroLandingPage/Accordion";
    import Newsletter from "../components/AeroLandingPage/Newsletter";
    import FooterMain from "../components/AeroLandingPage/FooterMain";
    import OffcanvasSearchBox from "../components/AeroLandingPage/OffcanvasSearchBox";
    import SassFeature from "../components/AeroLandingPage/SassFeature";

    // localStorage.clear();
    export default {
        name: "landing",
        components: {
            HeaderSoftware,
            HeroSoftware,
            BrandLogoCarousel,
            SassFeature,
            FeatureList,
            TabTwo,
            ProgressBar,
            PricingOne,
            CurveShape,
            CtaThree,
            FunFactOne,
            Accordion,
            Newsletter,
            FooterMain,
            OffcanvasSearchBox,
            ThreeStepProcessWrap,
        },
        created() {
            if (this.$route.fullPath === '/') {
                console.log("CLEARING THE LOCAL STORAGE at landing");
                localStorage.clear();
                this.$store.dispatch('logout')
            } else {
                console.log('Yes')
            }
            // window.location = "https://upgrademe.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=23hbvnv9ofhfj903skof5jrfgk&redirect_uri=http://localhost:5000/authentication"
        }

    };
</script>
